const getters = {
    getMe: state => state.me,
    getMeBasic: (state, getters) => {
        if (state.me) {
            return {
                userId: state.me.uid,
                userName: getters.getUserNames.fullName,
                companyId: state.me.customClaims ? parseInt(state.me.customClaims.companyId) : null
            }
        } else {
            return {userId: null, userName: null, companyId: null}
        }

    },
    getMyVirtualLocation: (state, getters) => {
        const companyId = getters.getMeBasic.companyId;
        let location = 123456789; // Demo account location as fallback :)
        switch (companyId) {
            case 7:
                location = 1042;
                break;
            case 11:
                location = 123456930;
                break;
            case 12:
                location = 123457079;
                break;
            case 13:
                location = 123457304;
                break;
            case 14:
                location = 123457384;
        }
        return location;
    },
    getUsers: state => state.users,
    getUserName: state => state.me.email.split('@', 1)[0],
    getActiveDepartment: (state,getters) => {

        if(getters.getMe){
             // todo refactor to fetch this automatically based on companies
            let label = _.find([{label: 'UDEN', value: 7}, {label: 'HRD', value: 11}, {label: 'HHW', value: 12}, {
                label: 'ZWG',
                value: 13
            },{
                label: 'HGV',
                value: 14
            }], {value: parseInt(state.me.customClaims.companyId)});
        return label ? label.label :''
        }else{
            return null
        }

    },
    getMyDepartments: state => {
        return [{label: 'UDEN', value: 7}, {label: 'HRD', value: 11}, {label: 'HHW', value: 12}, {
            label: 'ZWG',
            value: 13
        },{
            label: 'HGV',
            value: 14
        }]
    },
    getDepartmentLabel: state => (id) => {

        let c = _.find([{label: 'UDEN', value: 7}, {label: 'HRD', value: 11}, {label: 'HHW', value: 12}, {
            label: 'ZWG',
            value: 13
        },{
            label: 'HGV',
            value: 14
        }], {value: id})
        return c ? c.label : null

    },
    getUserNames: state => {
        let firstName = '';
        let lastName = '';
        let fullName = '';

        if (state.me.customClaims) {
            const nameSeparated = separateStringWithRegex(state.me.customClaims.name);
            firstName = nameSeparated[1];
            lastName = nameSeparated[0];
            fullName = firstName + ' ' + lastName;
        }

        return {firstName, lastName, fullName}
    }
}


function separateStringWithRegex(inputString) {
    // Define a regular expression pattern to match the desired content.
    let regexPattern = /([^()]+) \(([^)]+)\)/;

    // Use the `match` method to find and capture the parts of the string.
    let matches = inputString.match(regexPattern);

    // Check if there was a match and if there are at least two captured groups.
    if (matches && matches.length === 3) {
        let partBeforeBrackets = matches[1].trim();
        let partWithinBrackets = matches[2];
        return [partBeforeBrackets, partWithinBrackets];
    } else {
        // If no match is found, or if the structure is unexpected, return an error or handle it accordingly.
        return ["", inputString];
    }
}

export default getters